import { useContext, useCallback } from 'react';
import { InputControlsContext } from '@trinity/chat-components/components/BrandInsights/context';
import { useTelemetryLogger } from '@trinity/observability-web/react';

export const useChatTextInputControls = () => {
  // Context is undefined when rendered outside the chat input (e.g. the management app's markdown preview)
  const textAreaRef = useContext(InputControlsContext)?.textAreaRef;
  const loggerCtx = useTelemetryLogger();

  const focusChatInputTextArea = useCallback(() => {
    try {
      textAreaRef?.current?.focus();
    } catch (error) {
      loggerCtx.setContext('TextAreaFocusError', { textAreaExists: !!textAreaRef?.current });
      loggerCtx.captureException(error);
    }
  }, [loggerCtx, textAreaRef]);

  return {
    focusChatInputTextArea,
  };
};